import { getDatabase, ref, set } from 'firebase/database';
import constants from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const markSeen = ({ userId, notificationKey }) => {
  const db = getDatabase();
  const nodeRef = ref(db, `${constants.env}/notifications/${userId}/${notificationKey}/seen`);
  return set(nodeRef, true);
};
